export default __webpack_public_path__ + "media/design-system/side-panel/assets/back-b7a22bb53a3805d0ab1ebadf85ecb4eb.svg";